$(async function () {
    var $paymentElement = $('#payment-element');

    if ($paymentElement.length) {

        // get public key from controller
        var publicKey = await fetch('/api/stripe/PublicKey/Get', {
            method: 'GET'
        }).then(r => r.text());

        // create Stripe object w/ public key
        const stripe = Stripe(publicKey);

        // get amount in cents
        var $amountElement = $('#AmountTotal');
        var amountTotal = $amountElement.val();
        var amountInCents = Math.round(amountTotal * 100);

        // create payment intent
        const elements = stripe.elements({
            clientSecret: await fetch('/api/stripe/PaymentIntent/Create', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount: amountInCents })
            }).then(r => r.json()).then(r => r.clientSecret)
        });

        // mount payment element
        const paymentElement = elements.create('payment', { layout: 'accordion' });
        paymentElement.mount('#payment-element');

        // grab elements
        var $paymentForm = $("#payment-form");
        var $submitButton = $("#paymentBtn");
        var $paymentMessage = $('#payment-message');

        // add "customPayment" event listener that is triggered after recaptcha validation but before form post.
        $paymentForm.on("customPayment", async (event) => {
            event.preventDefault();

            // disable submit button
            disableButton($submitButton);

            // serverside validation
            var $paymentOptions = $('.payment__options input');
            var selectedPaymentOptionId = $paymentOptions.filter(':checked').val();
            var gRecaptchaResponse = $("#g-recaptcha-response").val();
            var validationResult = await fetch('/api/payment/validate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    amountTotal: amountTotal,
                    selectedPaymentOptionId: selectedPaymentOptionId,
                    rcResponse: gRecaptchaResponse
                }),
            }).then(r => r.json());

            // exit early and display error message if validation fails
            if (!(validationResult?.data)) {
                setPaymentMessage($paymentMessage, validationResult.messages?.join("\n") ?? "An unknown error occurred. Your card has not been charged.");
                enableButton($submitButton);
                return;
            } 

            // grab billing details
            var billingDetails = $("#stripeBillingDetails").data("billing-details");

            // process payment
            var confirmPaymentResponse = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: window.location.href,
                    payment_method_data: {
                        billing_details: billingDetails
                    }
                },
                redirect: 'if_required',
            })
            const { error, paymentIntent: confirmedPaymentIntent } = confirmPaymentResponse;
            var chargeResponse = {
                Id: confirmedPaymentIntent?.id,
                Amount: confirmedPaymentIntent?.amount,
                Paid: !error,
                ErrorMessage: error?.message
            }

            var confirmationResult = await fetch('/api/payment/confirm', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    selectedPaymentOptionId: selectedPaymentOptionId,
                    chargeResponse: chargeResponse
                }),
            }).then(r => r.json());

            // set error messages if any, else hit confirm method and redirect to confirmation page
            if (error) {
                // set error message
                setPaymentMessage($paymentMessage, error.message);
                // reenable button + reset recaptcha
                enableButton($submitButton);
            } else {
                console.log('Payment processed!');
                setPaymentMessage($paymentMessage, "");

                // redirect to order confirmation page
                if (confirmationResult?.success && confirmationResult?.data) {
                    window.location.replace(`/confirmation/${confirmationResult.data}`);
                }
            }
        });

        function disableButton($button) {
            $submitButton.prop("disabled", true);
            $submitButton.text("Processing...");
        }

        function enableButton($button) {
            $submitButton.prop("disabled", false);
            $submitButton.text("Complete My Order");
            grecaptcha.reset();
        }

        function setPaymentMessage($element, message) {
            $element.text(message);
        }
    }
});

function onPaymentSubmit(token) {
    var paymentOptions = document.querySelectorAll('.payment__options input');
    var selectedPaymentOptionId = [...paymentOptions]?.filter(elem => elem.matches(':checked'))?.find(x => x)?.value;

    // if no payment option selector, there is only one payment method
    if (!(paymentOptions?.length)) {
        // if that payment method is the CC form, 
        if ($('.payment__cc-form').length) {
            // go ahead and set the selected option to 1 (credit card)
            selectedPaymentOptionId = '1';
        }
    }

    // if this isn't a CC, just submit the form like normal
    if (selectedPaymentOptionId !== '1') {
        document.getElementById("payment-form").submit();
    }
    else {
        // else, this is a CC - dispatch custom Stripe payment event
        document.getElementById("payment-form").dispatchEvent(new CustomEvent("customPayment"));
    }
}

window.onPaymentSubmit = onPaymentSubmit;